import { config } from '@/components/Portfolio/config'
import { getSlidersForSuccessSections } from '@/helpers/getSlidersForSuccessSections'

export const configuration = {
  title: 'Success stories',
  subtitle:
    'Together with our partners, we’ve launched dozens of effective software products. Join the list of businesses that skyrocketed revenues and boosted performance using Modsen-developed cutting-edge Cloud and DevOps solutions.',
  config: getSlidersForSuccessSections(config.listValues, [
    '23',
    '24',
    '41',
    '40',
  ]),
  padding: '2%',
}
